export class PdocsSession {
    token: string
    expires: number

    public constructor() {
        this.token = null;
        this.expires = null;
    }

}